import { useMemo } from "react";

export const MATCH_ACCESSOR = [
  "Phone",
  "Telefono",
  "msisdn",
  "NUMERO",
  "numero",
  "phone",
  "telefono",
  "celular",
  "cel",
  "movil",
  "contacto",
  "contact",
  "número",
  "tel",
  "teléfono",
  "whatsapp",
  "wa",
  "Phone 1",
];

export const EMAIL_ACCESOR = [
  "Email",
  "Correo",
  "email",
  "correo",
  "Email 1",
  "Email 2",
  "email1",
  "email2",
];

function useHeaderKeys(data = [], type = "phone") {
  const mapAccesor = {
    phone: MATCH_ACCESSOR,
    email: EMAIL_ACCESOR,
  };

  return useMemo(() => {
    if (!data.length) return null;

    const keys = Object.keys(data[0]);
    const lowerKeys = keys.map((k) => k.toLowerCase());

    const match = mapAccesor[type]
      .map((m) => m.toLowerCase())
      .find((alias) => lowerKeys.includes(alias));

    if (!match) return null;

    return keys[lowerKeys.indexOf(match)];
  }, [data]);
}

export default useHeaderKeys;
